import { AppState } from './types'

export default {
  co2Emissions: null,
  energyConsumption: null,
  loadingPortfolioAggregationKpis: false
} as AppState
